module.exports = __webpack_public_path__ + "img/gate.ce27be0d.svg";